import { createContext } from 'react';
var WizardContext = /*#__PURE__*/createContext();
export default WizardContext;